export default __webpack_public_path__ + "static/media/usability.41be9107.png";